import { FormProvider } from 'react-hook-form'

import { useI18n } from '@tribeplatform/react-components/i18n'

import { SettingsLayout } from '../../Layout/SettingsLayout.js'

import { CommunityLanguageFormRenderer } from './CommunityLanguageFormRenderer.js'
import { useCommunityLanguageForm } from './useCommunityLanguageForm.js'

export const CommunityLanguage = () => {
  const { $t } = useI18n()

  const { form, onSubmit, isUpdating, localesLimit } =
    useCommunityLanguageForm()

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <SettingsLayout
          title={$t({
            defaultMessage: '{COMMUNITY_CC} language',
            id: 'Admin.LanguageSettings.CommunityLanguage',
          })}
          subtitle={$t({
            defaultMessage:
              'Set the default language for your community and choose which languages members can select from.',
            id: 'Admin.LanguageSettings.Description',
          })}
          disabled={!form.formState.isDirty}
          isLoading={isUpdating}
          onCancel={() => form.reset()}
          saveLabel={$t({
            defaultMessage: 'Update',
            id: 'Generics.Update',
          })}
        >
          <CommunityLanguageFormRenderer localesLimit={localesLimit} />
        </SettingsLayout>
      </form>
    </FormProvider>
  )
}
